import React from "react";
import Header from "../components/Header";
import Banner from "../components/Banner";
import '../components/css/Payment.css';

const YearlySuccess = () => {
  return (
    <>
      <Header />
      <Banner />
      <div className="dashboard success-page">
        <div className="subscription-card success-card gold">
          <h1>✔️</h1>
          <h2>Ročné predplatné aktivované!</h2>
          <p>Ďakujeme za vaše ročné predplatné. Vaše služby sú teraz aktívne po celý rok.</p>
          <a href="/" className="subscribe-button">Domov</a>
        </div>
      </div>
    </>
  );
};

export default YearlySuccess;
